import styled from 'styled-components';
import posed from 'react-pose';
import { Link } from 'gatsby';

import { colors, fonts, metrics } from '@/theme';

const { headerHeight, mobile } = metrics;

export const MenuContainer = styled(posed.div({
  enter: {
    y: '0%',
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 500,
      damping: 1000,
    },
  },
  exit: {
    y: '-150%',
    opacity: 0,
  },
}))`
  position: absolute;
  top: ${headerHeight.desktop}px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 99;
  padding: 0 85px;
  background: ${colors.white};
  max-width: 1270px;
  height: 700px;
  margin: 0 auto;
  opacity: 0;
  @media (max-width: ${mobile}px) {
    position: fixed;
    top: 60px;
    height: calc(100% - ${headerHeight.mobile}px);
    padding: 0 25px;
    overflow: auto;
  }
  @media (min-width: 1270px) {
    width: 100%;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  justify-content: ${({ align }) => align || 'flex-start'};
  width: 100%;
  height: 140px;
  @media (max-width: ${mobile}px) {
    height: 70px;
    border-top: 1px solid ${colors.black};
  }
`;

export const Item = styled(Link)`
  width: 100%;
  border-bottom: 3px solid ${colors.black};
  ${fonts.getTitle()}
  font-size: 120px;
  line-height: 124px;
  text-decoration: none;
  color: ${({ selected }) => (selected ? colors.link.active : colors.black)};
  transition: color .5s;
  @media (max-width: 1050px) {
    font-size: 115px;
  }
  @media (max-width: ${mobile}px) {
    font-size: 44px;
    line-height: 62px;
    border-bottom: none;
  }
  &:hover {
    color: ${({ selected }) => (selected ? colors.link.active : colors.blue)};
  }
  @media (max-width: 375px) {
    font-size: 40px;
  }
`;

export const StyledLink = styled(Link)`
  display: block;
  ${fonts.getRegularText()}
  color: ${({ selected }) => (selected ? colors.link.active : colors.black)};
  text-decoration: none;
  margin-bottom: 12px;
  transition: color .5s;
  &:hover {
    color: ${({ selected }) => (selected ? colors.link.active : colors.blue)};
  }
`;

export const BottomContainer = styled.div`
  margin-top: 10px;
`;

export const FootWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CopyRight = styled.div`
  ${fonts.getRegularText()}
  padding: 20px 0;
`;

export const Title = styled.p`
  font-size: 44px;
  margin: 0 0 6px 0;
  @media (max-width: 375px) {
    font-size: 40px;
    margin-bottom: 2px;
  }
`;
